import React, { Fragment, useEffect } from 'react'

import { WebhookSubscriber } from '../../../interfaces/Webhook'

import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import { getWebhook, updateWebhook } from '../config/api'
import { WebhookSubscriberForm } from './WebhookSubscriberForm'

interface WebhookFormEditProps {
  webhookSubscriber: WebhookSubscriber
  closeModal: (sucess: boolean) => void
  handleSnackbar: (message: string, success: boolean) => void
}

export const WebhookFormEdit: React.FC<WebhookFormEditProps> = ({
  webhookSubscriber,
  closeModal,
  handleSnackbar
}) => {
  const { state, callApi } = useApi()
  const {
    state: webhookSubscriberState,
    callApi: getWebhookSubscriberCallApi
  } = useApi<WebhookSubscriber>()

  const requestUpdateWebhook = (dto: WebhookSubscriber) => {
    callApi(updateWebhook(webhookSubscriber.webhookSubscriberId, dto))
      .then(() => {
        handleSnackbar('Webhook editado correctamente', true)
        closeModal(true)
      })
      .catch((error) => {
        handleSnackbar(error, false)
        closeModal(false)
      })
  }

  const [initialState, setInitialState] = React.useState<WebhookSubscriber>()

  useEffect(() => {
    requestGetWebhookSubscriber()
  }, [])

  const requestGetWebhookSubscriber = () => {
    getWebhookSubscriberCallApi(
      getWebhook(webhookSubscriber.webhookSubscriberId)
    )
      .then((response) => setInitialState(response))
      .catch((err) => console.log(err))
  }

  if (
    initialState === undefined ||
    state.status === Status.Loading ||
    webhookSubscriberState.status === Status.Loading
  ) {
    return <Loading />
  }

  return (
    <Fragment>
      <WebhookSubscriberForm
        initialValues={initialState}
        onSubmit={(el) => requestUpdateWebhook(el)}
      />
    </Fragment>
  )
}
